// Prevents the benign "ResizeObserver loop completed with undelivered
// notifications" error that resize-driven UI libraries (carousels, MUI, etc.)
// trigger. It is not a real bug, but CRA's dev error overlay surfaces it as a
// full-screen red error.
//
// Wrapping each ResizeObserver callback in requestAnimationFrame defers delivery
// to the next frame, which breaks the synchronous observe→resize→observe loop
// that produces the warning. Imported first in index.js so the constructor is
// patched before any component creates an observer.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}
